export default "__VITE_ASSET__B24GyDco__"